export const TREE_CONFIG = {
  // Node dimensions - adjusted for better fit
  NODE_WIDTH: 280,
  NODE_HEIGHT: 120,
  LEVEL_HEIGHT: 180,
  
  // Scale limits
  MIN_SCALE: 0.3,
  MAX_SCALE: 2,
  
  // Layout settings
  INITIAL_PADDING: 40,
  SIBLING_SPACING: 60,
  
  // Visual settings
  CONNECTOR: {
    COLOR: 'hsl(152 45% 40%)',
    WIDTH: 2
  },

  // Animation settings
  TRANSITION: {
    DURATION: 200,
    TIMING: 'ease-out'
  }
} as const;

export type TreeConfig = typeof TREE_CONFIG;